import React, { Suspense } from 'react';
import './Home.css';
import ReactPlayer from 'react-player';
import { Link } from 'react-router-dom';
import ContactUs from '../components/ContactUs';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

// import myVideo from 'test.mp4'
function Home() {
    const { t, i18n } = useTranslation();
    const changeLanguage = (lng:string) => {
        i18n.changeLanguage(lng);
      };
  return (
      <div className="Home">
        <button type="submit" onClick={() => changeLanguage('it')}>ITA</button>
        <button type="submit" onClick={() => changeLanguage('en')}>ENG</button>
        <div className='hero'>
            <h1 className='white'>{t('home.title')}</h1>
        </div>
    {/* <ReactPlayer
    url="test.mp4"
    // controls={true}
    loop={true}
    playsinline={true}
    muted={true}
    autoPlay={true}
    ></ReactPlayer> */}

    {/* SECTION 1 */}
    <section className='intro'>
        <div className='title'>
            <svg width="229" height="37" viewBox="0 0 229 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M227.768 20.2677C228.744 19.2914 228.744 17.7085 227.768 16.7322L211.858 0.822306C210.882 -0.154004 209.299 -0.154004 208.322 0.822306C207.346 1.79862 207.346 3.38153 208.322 4.35784L222.464 18.5L208.322 32.6421C207.346 33.6184 207.346 35.2013 208.322 36.1776C209.299 37.154 210.882 37.154 211.858 36.1776L227.768 20.2677ZM-9.42408e-05 21L226 21L226 16L-9.424e-05 16L-9.42408e-05 21Z" fill="url(#paint0_linear_18_1897)"/>
                <defs>
                <linearGradient id="paint0_linear_18_1897" x1="97.0027" y1="-6.50668" x2="237.003" y2="50.9919" gradientUnits="userSpaceOnUse">
                <stop offset="0.168324" stopColor="#11828A"/>
                <stop offset="1" stopColor="#3AAC92"/>
                </linearGradient>
                </defs>
            </svg>
            <span className='align-left'>{t('home.intro')}</span>
        </div>
        <div className='box-image-container flex-row-responsive space-around'>
            <div className='box-image'>
                <img src={require('../assets/atm_product.jpg')}/>
                <span>Payment solutions</span>
            </div>
            <div className='box-image'>
                <img src={require('../assets/atm_product.jpg')}/>
                <span>Software Integration</span>
            </div>
            <div className='box-image'>
                <img src={require('../assets/atm_product.jpg')}/>
                <span>Business Intelligence</span>
            </div>
        </div>
    </section>

    {/* PRODUCTS CATALOGUE */}
    <section>
        <div className='product' id="Sonda">
            <div>
                <h2>Sonda</h2>
                <p>The cryptocurrency exchange focused on retail and fiat</p>
            </div>
            <Link to="/crypto" className='primary white'>Open project</Link>
        </div>
        <div className='product' id="ATM">
            <div>
                <h2>Software for Retail</h2>
                <p>Software Suite for retail ATMs to sell digital products and public services to citizens.</p>
            </div>
            <Link to="/retail" className='primary white'>Open project</Link>
        </div>
        <div className='product' id="BOXi">
            <div>
                <h2>BOXi Vending</h2>
                <p>The technology to pay with smartphone at existing vending machines</p>
            </div>
            <Link to="/vending" className='primary white'>Open project</Link>
        </div>
    </section>
    <ContactUs
    title='Contact us'
    subtitle='Contact us'
    button='Contact us'
    ></ContactUs>
    </div>
  );
}

export default Home;